export const getFileBase64 = (fileObj) =>
  new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(e.target.result);
    reader.readAsDataURL(fileObj);
  });

export const getFilename = (fileObj) => fileObj.name.replace(/^.*\\/, '');
